import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import sb from '@/utils/sb'
import { supabaseAuthActions } from '@/utils/store/supabaseAuth'
import { type ActionFunctionArgs, type LoaderFunctionArgs, redirect, useFetcher, useLoaderData, useNavigate } from 'react-router'
import { useEffect, useState } from 'react'

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const supabase = sb
  const { data: { session } } = await supabase.auth.getSession()
  
  console.log('UpdatePassword loader - session:', session?.user?.id)
  
  if (!session) {
    console.warn('UpdatePassword: No active session, redirecting to login')
    return redirect('/s_auth/login?error=' + encodeURIComponent('请先登录以重置密码'))
  }
  
  return { session }
}

export const action = async ({ request }: ActionFunctionArgs) => {
  // const { supabase, headers } = createClient(request)
  const supabase = sb;
  const formData = await request.formData()
  const password = formData.get('password') as string

  if (!password) {
    return { error: '密码不能为空' }
  }

  const { error } = await supabase.auth.updateUser({ password: password })

  if (error) {
    return {
      error: error instanceof Error ? error.message : 'An error occurred',
    }
  }

  // 返回成功标识，不直接重定向
  return { success: true }
}

export default function Page() {
  const { session } = useLoaderData<typeof loader>()
  const fetcher = useFetcher<typeof action>()
  const navigate = useNavigate()
  const [countdown, setCountdown] = useState(3)

  const error = fetcher.data?.error
  const success = fetcher.data?.success
  const loading = fetcher.state === 'submitting'

  // 修改密码成功后3秒自动跳转到首页
  useEffect(() => {
    if (success) {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer)
            navigate('/', { replace: true })
            return 0
          }
          return prev - 1
        })
      }, 1000)

      return () => clearInterval(timer)
    }
  }, [success, navigate])

  console.log('UpdatePassword render:', { 
    hasSession: !!session, 
    userId: session?.user?.id,
    loading,
    error,
    success
  })

  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm">
        <div className="flex flex-col gap-6">
          {success ? (
            <Card>
              <CardHeader>
                <CardTitle className="text-2xl">密码修改成功！</CardTitle>
                <CardDescription>您的密码已更新</CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground mb-4">
                  您的密码已成功修改，{countdown} 秒后自动跳转到首页...
                </p>
                <Button 
                  className="w-full"
                  onClick={() => navigate('/', { replace: true })}
                >
                  立即前往首页
                </Button>
              </CardContent>
            </Card>
          ) : (
            <Card>
              <CardHeader>
                <CardTitle className="text-2xl">重置您的密码</CardTitle>
                <CardDescription>请在下方输入您的新密码。</CardDescription>
              </CardHeader>
              <CardContent>
                <fetcher.Form method="post">
                  <div className="flex flex-col gap-6">
                    <div className="grid gap-2">
                      <Label htmlFor="password">新密码</Label>
                      <Input
                        id="password"
                        name="password"
                        type="password"
                        placeholder="新密码"
                        required
                      />
                    </div>
                    {error && <p className="text-sm text-red-500">{error}</p>}
                    <Button type="submit" className="w-full" disabled={loading}>
                      {loading ? '保存中...' : '保存新密码'}
                    </Button>
                  </div>
                </fetcher.Form>
              </CardContent>
            </Card>
          )}
        </div>
      </div>
    </div>
  )
}
